var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 7.99431L3.5221 11.4721C3.39198 11.6023 3.22637 11.6673 3.02527 11.6673C2.82417 11.6673 2.65856 11.6023 2.52844 11.4721C2.39831 11.342 2.33325 11.1764 2.33325 10.9753C2.33325 10.7742 2.39831 10.6086 2.52844 10.4785L6.00626 7.00065L2.52844 3.52283C2.39831 3.39271 2.33325 3.2271 2.33325 3.026C2.33325 2.8249 2.39831 2.65929 2.52844 2.52917C2.65856 2.39905 2.82417 2.33398 3.02527 2.33398C3.22637 2.33398 3.39198 2.39905 3.5221 2.52917L6.99992 6.00699L10.4777 2.52917C10.6079 2.39905 10.7735 2.33398 10.9746 2.33398C11.1757 2.33398 11.3413 2.39905 11.4714 2.52917C11.6015 2.65929 11.6666 2.8249 11.6666 3.026C11.6666 3.2271 11.6015 3.39271 11.4714 3.52283L7.99358 7.00065L11.4714 10.4785C11.6015 10.6086 11.6666 10.7742 11.6666 10.9753C11.6666 11.1764 11.6015 11.342 11.4714 11.4721C11.3413 11.6023 11.1757 11.6673 10.9746 11.6673C10.7735 11.6673 10.6079 11.6023 10.4777 11.4721L6.99992 7.99431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8ff0711adf524456429b32b737a1ef2c.svg";
export { ForwardRef as ReactComponent };